// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"809":"users","854":"widgets"}[chunkId] + "." + {"809":"da1a21e8","854":"761ce50a"}[chunkId] + ".css";
};